import Vue from 'vue';
import helpers from "./mixins/helpers";
if(document.getElementById('order-certificate')){
    $(document).ready(function() {

        var countrySelect = $("#certificate-order-country_id");
        var citySelect = $("#certificate-order-city_id");

        countrySelect.select2({
            placeholder: "Введите страну",
            theme: 'select-city',
            allowClear: false,
            doReset:false
        });

        citySelect.select2({
            placeholder: "Введите город",
            theme: 'select-city',
            allowClear: true,
            doReset:true,
            templateResult: function (data) {
                if (data.region) {
                    return data.text + ", " + data.region;
                }

                return data.text;
            },
            ajax: {
                url: "/data/city-list",
                data: function (params) {
                    var query = {
                        q: params.term,
                        country: orderCertificate.country
                    };
                    return query;
                },

                cache: true
            }
        });

        countrySelect.val(1);
        citySelect.val(citySelect.find('option:eq(0)').val());

        $(".search-sity").trigger('change');

    });
    let orderCertificate = new Vue({
        mixins: [helpers],
        el:'#order-certificate',
        data:{
            order:order,
            certificates:certificates,
            load:false,
            errorMessage:null,
            country:1,
            city:$("#certificate-order-city_id").find('option:eq(0)').val()
        },
        methods:{
            addToOrder(id){
                var self = this;
                $.ajax({
                    url:"/user/certificate/add-to-order/"+id,

                    success:function(data){
                        self.order = data;
                    },
                    fail:function(data){

                        self.errorMessage = data.responseJSON.message;

                    }
                });
            },
            deleteFromOrder(id){
                let self = this;

                $.ajax({
                    url:"/user/certificate/delete-from-order/"+id,

                    success:function(data){

                        self.order = data;

                    },
                    error:function(data){

                        self.errorMessage = data.responseJSON.message;

                    }
                });

            },
            inOrder(id){
                let self = this;
                if(this.order.items !== null){
                    return self.in(id.toString(),Object.keys(this.order.items));

                } else{

                    return false;

                }

            }
        }
    });
}
